import {
  TrendingDown,
  Moon,
  Trash2,
  HardDrive,
  Cpu,
  Network,
  ShieldCheck,
  CalendarCheck,
  Clock,
  TrendingUp,
  BrainCircuit,
  type LucideIcon,
} from 'lucide-react';
import type { RecommendationCategory } from '@lizrd/contracts';

/**
 * Presentation metadata for recommendation categories — label, a lucide icon, and a
 * stable distinct color for charts/bars. Kept here (not in the Cost Optimization
 * page's local map) so dashboard widgets can share it without a cross-module
 * dependency. Colors are data-viz hues (like the chart palette), not UI tokens.
 */
export const RECO_CATEGORY_META: Record<
  RecommendationCategory,
  { label: string; icon: LucideIcon; color: string }
> = {
  rightsize: { label: 'Right-sizing', icon: TrendingDown, color: 'var(--iris)' },
  idle: { label: 'Idle resources', icon: Moon, color: 'hsl(38 80% 55%)' },
  orphaned: { label: 'Orphaned resources', icon: Trash2, color: 'hsl(0 65% 58%)' },
  storage: { label: 'Storage tiering', icon: HardDrive, color: 'hsl(265 55% 62%)' },
  modernize: { label: 'Architecture modernization', icon: Cpu, color: 'hsl(210 70% 58%)' },
  network: { label: 'Networking', icon: Network, color: 'hsl(180 55% 45%)' },
  reliability: { label: 'Reliability scale-up', icon: ShieldCheck, color: 'hsl(30 15% 55%)' },
  commitment: { label: 'Commit & save', icon: CalendarCheck, color: 'hsl(150 45% 48%)' },
  schedule: { label: 'Off-hours scheduling', icon: Clock, color: 'hsl(200 70% 52%)' },
  autoscale: { label: 'Autoscaling', icon: TrendingUp, color: 'hsl(280 60% 60%)' },
  ai: { label: 'AI & LLM token economics', icon: BrainCircuit, color: 'hsl(325 65% 62%)' },
};
